import React, { Component } from 'react';
import OdourAssessment from '../../components/odour-assessment-form/OdourAssessment';
import { saveAssesment } from '../../services/assessment';
import firebase from 'firebase/app';
import 'firebase/auth';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Heatmap from '../../components/HeatMap';
import { validateAssessment } from '../../services/validators';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css



function ErrorView(props) {
    return (<div className='view-container'>
        <h2>Sorry!</h2>
        <p>Unfortunatley, something has gone wrong. This issue will be fixed soon. Please come back and try again soon.</p>
    </div>)
}

function LoadingView() {
    return (<div className="view-container">
        <div className='spinner'></div>
    </div>)
}
export default class OdourSurveyFlow extends Component {
    state = {
        viewName: 'loading'
    }

    constructor() {
        super()
        this.onNewOdourAssessment = this.onNewOdourAssessment.bind(this);
        this.confirmSubmit = this.confirmSubmit.bind(this);
    }

    componentDidMount() {
        firebase.auth().onAuthStateChanged(user => {
            console.log('User has registered.', user.uid)
            this.setState({ viewName: 'assessment' })
            this.setState({ user: user })
        });
        firebase.auth().signInAnonymously().catch(error => {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            this.setState({ viewName: 'error' })
            console.error(errorCode, errorMessage)
        });

    }

    confirmSubmit (state) {
        const uid = firebase.auth().currentUser.uid;
        this.setState({ viewName: 'loading' })
        saveAssesment({ uid, ...state })
            .then((assessmentRef) => {
                this.setState({ assessmentRef })
                this.setState({ viewName: 'confirm' })
            })
            .catch((err) => {
                console.log('set state to error:', err)
                this.setState({ viewName: 'error' })
            })
    }

    onNewOdourAssessment(state) {
        const uid = firebase.auth().currentUser.uid;
        const validatorMessages = validateAssessment({ uid, ...state });
        if (validatorMessages.length === 0) {
            if (state.intensity === 1) { // Do not smell option
                // show the confirmation here
                confirmAlert({
                    title: 'You have told us there is no odour.',
                    message: '',
                    buttons: [
                        {
                            label: 'Yes, there is no odour',
                            onClick: () => this.confirmSubmit(state)
                        },
                        {
                            label: 'I will change my report'
                        }
                    ]
                })

            } else {
                this.confirmSubmit(state)
            }

        } else {
            this.setState({ validatorMessages })
        }

    }

    render() {
        const viewName = this.state.viewName;
        const validatorMessages = this.state.validatorMessages ? this.state.validatorMessages : [];
        const views = {
            confirm: () => (<Heatmap afterSubmit={true}></Heatmap>),
            assessment: () => (<OdourAssessment validatorMessages={validatorMessages} onSubmit={this.onNewOdourAssessment}></OdourAssessment>),
            error: () => (<ErrorView></ErrorView>),
            loading: () => (<LoadingView />)
        }
        let activeView = views[viewName];
        if (!activeView) {
            activeView = () => (<h1>Unkonwn view {viewName}</h1>)
        }
        return (
            <div>
                {this.state.viewName === "confirm" ? <Header goback></Header> : <Header></Header>}
                {activeView()}
                {<Footer></Footer>}
            </div>
        );
    }
}
